import { GetOneQuizInDto, GetOneQuizOutDto } from "../../../types/quiz.dto";

export const GET_ONE_QUIZ = "GET_ONE_QUIZ";
export const GET_ONE_QUIZ_SUCCESS = "GET_ONE_QUIZ_SUCCESS";
export const GET_ONE_QUIZ_ERROR = "GET_ONE_QUIZ_ERROR";
export const RESET_GET_ONE_QUIZ = "RESET_GET_ONE_QUIZ";

export interface GetOneQuiz {
  type: typeof GET_ONE_QUIZ;
  payload: GetOneQuizOutDto;
}

export interface GetOneQuizSuccess {
  type: typeof GET_ONE_QUIZ_SUCCESS;
  payload: GetOneQuizInDto;
}

export interface GetOneQuizError {
  type: typeof GET_ONE_QUIZ_ERROR;
  payload: string | boolean;
}

export interface ResetGetOneQuiz {
  type: typeof RESET_GET_ONE_QUIZ;
  payload: null;
}

export interface State {
  data: GetOneQuizInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetOneQuiz
  | GetOneQuizSuccess
  | GetOneQuizError
  | ResetGetOneQuiz;
